export default "__VITE_ASSET__ChjDViuX__"